"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var ClientsList = /*#__PURE__*/function () {
  function ClientsList(client) {
    (0, _classCallCheck2["default"])(this, ClientsList);
    this.client = client;
    this.resourceUrl = '/client';
  }

  (0, _createClass2["default"])(ClientsList, [{
    key: "getclientsList",
    value: function getclientsList(id) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return this.client.get("".concat(this.resourceUrl, "/coach/").concat(id), args);
    }
  }]);
  return ClientsList;
}();

exports["default"] = ClientsList;